<script>
	import { onMount } from 'svelte';


	export let params = {};

	onMount(() => {
		if (params.referral_code) {
			localStorage.setItem('RefCode', params.referral_code);
		}
		window.location.href = '/';
	});
</script>